import { cn, Separator } from '@hub-la/shadcn'
import React from 'react'

type Props = {
  title: string
  content: React.ReactElement
  fontWeight?: 'bold' | 'lighter'
  showDivider?: boolean
}

export const ContentRow = ({ title, content, fontWeight, showDivider = false }: Props) => {
  return (
    <div className="w-full flex flex-col gap-2">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between space-y-1 lg:space-y-0 lg:space-x-1">
        <div className="flex items-center gap-2">
          <p className={cn('text-base', fontWeight === 'bold' ? 'font-bold' : 'font-normal')}>{title}</p>
        </div>

        {content}
      </div>

      {showDivider && <Separator className="my-2" />}
    </div>
  )
}
